import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ProductPriceElementPrice from '../ProductPriceElementPrice';
import ProductPriceElementDiscounPercent from '../ProductPriceElementDiscounPercent';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    fullWidth: {
      width: '100%'
    },
    percent: {
      marginLeft: theme.spacing(2)
    }
  };
}, {
  name: 'SxComProductPriceStandard'
});

function ProductPriceStandard(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      discountAbsolute = _ref.discountAbsolute,
      discountPercent = _ref.discountPercent,
      isDiscount = _ref.isDiscount,
      noTaxPrices = _ref.noTaxPrices,
      price = _ref.price,
      priceLabelEnd = _ref.priceLabelEnd,
      priceLabelStart = _ref.priceLabelStart,
      priceOriginal = _ref.priceOriginal,
      priceOriginalWithTax = _ref.priceOriginalWithTax,
      priceWithTax = _ref.priceWithTax,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "currency", "discountAbsolute", "discountPercent", "isDiscount", "noTaxPrices", "price", "priceLabelEnd", "priceLabelStart", "priceOriginal", "priceOriginalWithTax", "priceWithTax"]);

  var classes = useStyles({
    classes: pClasses
  });
  var priceProps = {
    value: noTaxPrices ? price : priceWithTax,
    currency: currency,
    fullWidth: true,
    size: 'large',
    labelEnd: priceLabelEnd,
    labelStart: priceLabelStart
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), !isDiscount ? /*#__PURE__*/React.createElement(ProductPriceElementPrice, priceProps) : /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.fullWidth)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement(ProductPriceElementPrice, {
    value: noTaxPrices ? priceOriginal : priceOriginalWithTax,
    currency: currency,
    size: "small",
    decoration: "strike"
  }), /*#__PURE__*/React.createElement(ProductPriceElementDiscounPercent, {
    value: discountPercent * -1,
    currency: currency,
    className: classes.percent,
    size: "small"
  })), /*#__PURE__*/React.createElement(ProductPriceElementPrice, priceProps)));
}

ProductPriceStandard.propTypes = {
  classes: PropTypes.shape({
    fullWidth: PropTypes.string,
    percent: PropTypes.string,
    root: PropTypes.string,
    row: PropTypes.string
  }),
  className: PropTypes.string,
  currency: PropTypes.string.isRequired,
  discountAbsolute: PropTypes.number,
  discountPercent: PropTypes.number,
  isDiscount: PropTypes.bool,
  noTaxPrices: PropTypes.bool.isRequired,
  price: PropTypes.number,
  priceLabelEnd: PropTypes.node,
  priceLabelStart: PropTypes.node,
  priceOriginal: PropTypes.number,
  priceOriginalWithTax: PropTypes.number,
  priceWithTax: PropTypes.number
};
ProductPriceStandard.defaultProps = {
  classes: undefined,
  className: undefined,
  discountAbsolute: undefined,
  discountPercent: undefined,
  isDiscount: false,
  price: undefined,
  priceLabelEnd: undefined,
  priceLabelStart: undefined,
  priceOriginal: undefined,
  priceOriginalWithTax: undefined,
  priceWithTax: undefined
};
export default ProductPriceStandard;